import React from 'react';
import { Input, CustomInput, FormFeedback } from 'reactstrap';
import Select from 'react-select';

export const range = (start, end) => Array.from({ length: (end - start) }, (v, k) => k + start);
export const required = (value) => {
  if (value === undefined || value === null) {
    return '必須';
  }
  if (typeof value === 'string') {
    if (value === '' || value === 'お選びください') {
      return '必須';
    }
  }
  return (value || typeof value === 'number' ? undefined : '必須');
};
export const toNumber = (value) => {
  if (value === 'お選びください') {
    return undefined;
  }
  return value && typeof value === 'string' ? Number.parseInt(value, 10) : value;
};
export const numberOnly = (value) => value && value.replace(/[^0-9]/g, '');
export const email = (value) => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'メールアドレスの形式が不正です' : undefined);
export const postCode = (value) => (value && !/^\d{7}$/.test(value) ? '郵便番号の形式が不正です' : undefined);
export const kana = (value) => (value && !/^([ァ-ン]|ー)+$/.test(value) ? 'カタカナで入力してください' : undefined);
export const maxLength = (max) => (value) => (value && value.length > max ? `${max} 文字以下で入力してください` : undefined);
export const minLength = (min) => (value) => (value && value.length < min ? `${min} 文字以上で入力してください` : undefined);
export const credit = (value) => (value && !/^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/.test(value) ? 'クレジットカードの形式が不正です' : undefined);
export const lessThan = (max) => (value) => {
  const input = parseInt(value, 10);
  if (Number.isNaN(input)) {
    return '';
  }
  if (input < 0) {
    return '';
  }
  return input > parseInt(max, 10) ? max : input;
};
export const renderInput = ({
  input,
  type,
  placeholder,
  meta: { touched, error },
  children,
  label,
  id,
  className,
  defaultValue,
  options,
  disabled,
  // style,
}) => {
  let result = null;
  switch (type) {
    case 'select':
      result = (
        <CustomInput
          {...input}
          placeholder={placeholder}
          type={type}
          valid={touched && !error}
          invalid={touched && error !== undefined}
          id={id}
          disabled={disabled}
        >
          { children}
        </CustomInput>
      );
      break;
    case 'radio':
    case 'checkbox':
    case 'switch':
      result = (
        <CustomInput
          {...input}
          type={type}
          label={label}
          id={id}
          className={className}
          disabled={disabled}
          checked={type === 'checkbox' ? !!input.value : input.checked}
        />
      );
      break;
    case 'autocomplete':
      result = (
        <Select
          {...input}
          options={options}
        />
      );
      break;
    default:
      result = (
        <Input
          {...input}
          defaultValue={defaultValue}
          placeholder={placeholder}
          type={type}
          valid={touched && !error}
          invalid={touched && error !== undefined}
          disabled={disabled}
        />
      );
  }
  return (
    <>
      { result }
      {touched && error && (<FormFeedback>{error}</FormFeedback>)}
    </>
  );
};

export const Required = () => <span className="required">必須</span>;
export const Optional = () => <span className="optional">任意</span>;
